import React from "react";

const WhyChooseUs = () => {
  return (
    <section>
      <div className="str">
        <div className="ban-inn ban-home">
          <div className="container">
            <div className="row">
              <div className="hom-ban">
                <div className="ban-tit">
                  <span>
                    <i className="no1">#1</i> Wedding Website
                  </span>
                  <h2>Why choose us</h2>
                  <p>
                    Most Trusted and premium Matrimony Service in the World.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
